import React, { useState } from 'react';
import RTModal from '../common/RTModal';
import RTButton from '../common/RTButton';
import PaymentReceiptPrint from './PaymentReceiptPrint';
import './PaymentSuccessModal.css';

const PaymentSuccessModal = ({
  isOpen,
  onClose,
  paymentData,
  onNavigateToPayments,
}) => {
  const [showReceipt, setShowReceipt] = useState(false);

  if (!paymentData) return null;

  const {
    payment_created,
    payment,
    total_amount_processed,
    pg_details,
    payment_date,
    payment_method,
    reference_number,
  } = paymentData;

  const paymentInfo = payment_created || payment;

  const handlePrintReceipt = () => {
    setShowReceipt(true);
  };

  const handleReceiptPrinted = () => {
    setShowReceipt(false);
    onClose();
    onNavigateToPayments();
  };

  const handleClose = () => {
    onClose();
    onNavigateToPayments();
  };

  const handleViewPayment = () => {
    onClose();
    window.location.href = `/payments/${paymentInfo?.payment_id}/view`;
  };

  if (showReceipt) {
    return (
      <PaymentReceiptPrint
        paymentId={paymentInfo?.payment_id}
        onClose={handleReceiptPrinted}
      />
    );
  }

  const footer = (
    <>
      <RTButton variant="secondary" onClick={handleClose}>
        Close
      </RTButton>
      <RTButton variant="secondary" onClick={handleViewPayment}>
        View Payment
      </RTButton>
      <RTButton variant="primary" onClick={handlePrintReceipt}>
        Print Receipt
      </RTButton>
    </>
  );

  return (
    <RTModal
      isOpen={isOpen}
      onClose={handleClose}
      title="Payment Successful!"
      footer={footer}
      size="medium"
    >
      <div className="payment-success-content">
        <p className="receipt-number">Receipt #{paymentInfo?.payment_id}</p>
        <div className="payment-summary">
          <div className="summary-grid">
            <div className="summary-item">
              <span className="label">Paying Guest:</span>
              <span className="value">{pg_details?.name}</span>
            </div>
            <div className="summary-item">
              <span className="label">Total Amount Processed:</span>
              <span className="value amount">
                ₹{total_amount_processed?.toFixed(2)}
              </span>
            </div>
            <div className="summary-item">
              <span className="label">Payment Method:</span>
              <span className="value">{payment_method}</span>
            </div>
            <div className="summary-item">
              <span className="label">Payment Date:</span>
              <span className="value">
                {new Date(payment_date).toLocaleDateString()}
              </span>
            </div>
            {reference_number ? (
              <div className="summary-item">
                <span className="label">Reference Number:</span>
                <span className="value">{reference_number}</span>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </RTModal>
  );
};

export default PaymentSuccessModal;
